module.exports = "//static.hsappstatic.net/avatar-components/static-1.21/images/default-avatar.png"